export var replaceJSSString = function replaceJSSString() {
  var modelString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var value = modelString.replace("{copyrightYear}", new Date().getFullYear());
  return {
    value: value
  };
};